import { isEmpty as isHtmlEmpty } from '@paintscout/util/util'
import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty({ estimator }: PresentationIsEmptyProps) {
  const description = estimator?.description ?? ''
  const hasContent = description && !isHtmlEmpty(description)

  if (!estimator?.image && !hasContent) {
    return true
  }

  return false
}
